import FileReferenceDefinition from '../FileReferenceDefinition';

const definition: FileReferenceDefinition = {
  name: 'AndroidGeckoClientCertificateRequestedEventArgs',
  type: 'class',
  description: 'Event args for [AndroidGeckoWebView.ClientCertificateRequested](/webview/AndroidGeckoWebView#ClientCertificateRequested). If the application attaches a handler to this event, when the event is raised due to a client certificate request, the app must invoke [Select()](#Select) to resume the web page.',
  inheritsFrom: 'System.EventArgs',
  members: [
    {
      name: 'Host',
      returns: 'string',
      type: 'property',
      description: 'The host that requested the certificate.',
    },
    {
      name: 'Select',
      returns: 'void',
      type: 'method',
      arguments: [
        {
          name: 'certificateAlias',
          type: 'string'
        }
      ],
      description: 'Completes the request by responding with the alias of the selected certificate (or `null` if none was selected).'
    },
  ]
};
export default definition;
